import { px } from '@mantine/core';
import { space } from '@repo/theme/primitives';

export const TICK_LABEL_TO_AXIS_PADDING = 8;
export const AXIS_TITLE_TO_TICK_LABEL_PADDING = 16;
export const COMMON_PADDING = 16;

// PIE CHART CONSTANTS
export const PIE_CHART_WIDTH_FOR_EACH_PIE = 24;
export const PIE_CHART_CORNER_RADIUS = 3;
export const PIE_CHART_MAIN_TEXT_SIZE = 32;
export const PIE_CHART_SUB_TEXT_SIZE = 12;
export const PIE_CHART_GAP =
	PIE_CHART_MAIN_TEXT_SIZE - Number(px(space[1])) / 2;
export const SCATTER_CHART_DOT_RADIUS = 3.5;
